export default __webpack_public_path__ + "static/media/BUR.bdf8328c.svg";